module.exports = __webpack_public_path__ + "static/media/p1-6.3be718e9.png";